// Shared vocabulary; costs are always calculated and persisted by the server.
const STOCK_ADJUSTMENT_REASONS = Object.freeze([
  { value: "inventory_difference", label: "Écart d’inventaire" },
  { value: "damage", label: "Casse / détérioration" },
  { value: "expiry", label: "Péremption" },
  { value: "theft", label: "Vol / disparition" },
  { value: "internal_use", label: "Consommation interne" },
  { value: "donation", label: "Don / échantillon" },
  { value: "data_correction", label: "Correction de saisie" },
  { value: "other", label: "Autre motif" },
  { value: "unspecified", label: "Motif non précisé" },
]);

const STOCK_ADJUSTMENT_COST_LABELS = Object.freeze({
  fifo_lots: "Coût des lots consommés en FIFO",
  lot_weighted_average: "Coût moyen des lots disponibles",
  last_documented_lot: "Dernier coût de lot documenté",
  last_documented_purchase: "Dernier coût d’achat documenté",
  historical_reversal: "Annulation au coût historique",
  legacy_unvalued: "Ancien ajustement sans valeur historisée",
  non_physical_stock: "Produit sans stock physique valorisé",
});

const adjustmentReasonLabel = (value) => STOCK_ADJUSTMENT_REASONS.find(reason => reason.value === value)?.label || "Motif non précisé";
const hasAdjustmentValuation = (row) => Boolean(row?.valuation_event_id) &&
  row?.total_cost_snapshot !== null && row?.total_cost_snapshot !== undefined &&
  Number.isFinite(Number(row.total_cost_snapshot)) &&
  row?.stock_value_delta !== null && row?.stock_value_delta !== undefined &&
  Number.isFinite(Number(row.stock_value_delta)) && Boolean(row.valuation_currency);

const formatAdjustmentValue = (row) => {
  if (!hasAdjustmentValuation(row)) return row?.valuation_state === "not_applicable" ? "Hors stock valorisé" : "Non valorisé";
  const amount = Number(row.stock_value_delta);
  const currency = row.valuation_currency;
  const decimals = ["XOF", "XAF"].includes(currency) ? 0 : 2;
  return `${amount > 0 ? "+" : ""}${new Intl.NumberFormat("fr-FR", { minimumFractionDigits: decimals, maximumFractionDigits: decimals }).format(amount)} ${currency}`;
};

module.exports = { STOCK_ADJUSTMENT_REASONS, STOCK_ADJUSTMENT_COST_LABELS, adjustmentReasonLabel, hasAdjustmentValuation, formatAdjustmentValue };
